module.exports = __webpack_public_path__ + "img/PJLA2.2287c01e.png";